export default "__VITE_ASSET__BQz09oBr__"